export default function AuthLogout() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50 p-4">
      <div className="max-w-md text-center">
        <h2 className="text-lg font-semibold text-slate-800 mb-2">Signed out</h2>
        <p className="text-sm text-slate-600 mb-4">You have been logged out.</p>
        <a
          href="/"
          className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Sign in again
        </a>
      </div>
    </div>
  );
}
